/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface CentreSpendAttributionData
 */
export interface CentreSpendAttributionData {
    /**
     * 
     * @type {boolean}
     * @memberof CentreSpendAttributionData
     */
    complete: boolean;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CentreSpendAttributionData
     */
    assignedSpendMarketing: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof CentreSpendAttributionData
     */
    unassignedSpendMarketing: MoneyOutput;
    /**
     * 
     * @type {number}
     * @memberof CentreSpendAttributionData
     */
    unmappedSourceCount: number;
    /**
     * 
     * @type {number}
     * @memberof CentreSpendAttributionData
     */
    ambiguousSourceCount: number;
    /**
     * 
     * @type {string}
     * @memberof CentreSpendAttributionData
     */
    referenceScope: string;
}

/**
 * Check if a given object implements the CentreSpendAttributionData interface.
 */
export function instanceOfCentreSpendAttributionData(value: object): value is CentreSpendAttributionData {
    if (!('complete' in value) || value['complete'] === undefined) return false;
    if (!('assignedSpendMarketing' in value) || value['assignedSpendMarketing'] === undefined) return false;
    if (!('unassignedSpendMarketing' in value) || value['unassignedSpendMarketing'] === undefined) return false;
    if (!('unmappedSourceCount' in value) || value['unmappedSourceCount'] === undefined) return false;
    if (!('ambiguousSourceCount' in value) || value['ambiguousSourceCount'] === undefined) return false;
    if (!('referenceScope' in value) || value['referenceScope'] === undefined) return false;
    return true;
}

export function CentreSpendAttributionDataFromJSON(json: any): CentreSpendAttributionData {
    return CentreSpendAttributionDataFromJSONTyped(json, false);
}

export function CentreSpendAttributionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CentreSpendAttributionData {
    if (json == null) {
        return json;
    }
    return {
        
        'complete': json['complete'],
        'assignedSpendMarketing': MoneyOutputFromJSON(json['assignedSpendMarketing']),
        'unassignedSpendMarketing': MoneyOutputFromJSON(json['unassignedSpendMarketing']),
        'unmappedSourceCount': json['unmappedSourceCount'],
        'ambiguousSourceCount': json['ambiguousSourceCount'],
        'referenceScope': json['referenceScope'],
    };
}

export function CentreSpendAttributionDataToJSON(json: any): CentreSpendAttributionData {
    return CentreSpendAttributionDataToJSONTyped(json, false);
}

export function CentreSpendAttributionDataToJSONTyped(value?: CentreSpendAttributionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'complete': value['complete'],
        'assignedSpendMarketing': MoneyOutputToJSON(value['assignedSpendMarketing']),
        'unassignedSpendMarketing': MoneyOutputToJSON(value['unassignedSpendMarketing']),
        'unmappedSourceCount': value['unmappedSourceCount'],
        'ambiguousSourceCount': value['ambiguousSourceCount'],
        'referenceScope': value['referenceScope'],
    };
}

